import NotFoundCard from 'components/NotFoundCard/NotFoundCard'
import styled from 'styled-components/macro'

/**
 * NotFoundContent - 404 page content for use inside AppLayout
 * This version doesn't include its own nav/footer since AppLayout provides those
 */
export function NotFoundContent() {
  return (
    <Container>
      <NotFoundCard />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 24px;
`
